<svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 3.33333L5.4 8L12 1" stroke="#B8B8B8" strokeWidth="1"/>
</svg>
